<template>
  <div>

    <v-card>
      <v-card-title>Listado de Faenas</v-card-title>
      <v-card-text>

        <botonera :botones="botones" alinear="right"
        @crear="dialog = !dialog"
        ></botonera>

        
      </v-card-text>
    </v-card>

    <datatable :cabeceras="faenasListHeaders" :items="faenasListBody" titulo="Listado de Faenas" label="Escriba Para buscar Faena" icono="list" color_icono="azul"
    :tachar="false"
    :acciones="['editar','eliminar']"
    @editar="editFaena($event)"
    @eliminar="deleteFaena($event)">
    </datatable>

    <!-- <v-data-table 
        :headers="faenasListHeaders"
        :items="faenasListBody"
        class="elevation-1"
        no-data-text="No hay faenas"
        :search="search"
    >
      <template v-slot:[`item.actions`]="{item}">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              @click="editFaena(item)"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar Faena</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              @click="deleteFaena(item)"
              v-on="on"
            >
            mdi-delete
            </v-icon>
          </template>
          <span>Eliminar Faena</span>
        </v-tooltip>
      </template>
    </v-data-table> -->

    <!-- Modal Nueva Faena -->
    <v-dialog
      v-model="dialog"
      width="800px"
      @click:outside = "closeModal"
    >
      <v-card>
        <v-card-title class="blue darken-1">{{ title }}</v-card-title>
        <v-card-text>
          <v-row class="mx-2">
            <v-col
              class="align-center justify-space-between"
              cols="6"
            >
              <v-text-field
                prepend-icon="mdi-barcode"
                placeholder="Nombre"
                v-model="faena.nombre"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
              <v-btn
                @click="closeModal"
              >Cerrar</v-btn>
              <v-btn
                color="primary"
                @click="saveFaena"
              >Grabar</v-btn>
        </v-card-actions>
              
      </v-card>
    </v-dialog>
    <!-- / Modal -->
    
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      title: 'Nueva Faena',
      color: 'green',
      snackbar: false,
      errors: [],
      validation_message: '',
      success: null,
      search: null,
      file: null,
      dialog: false,
      faenaIndex: -1,
      faena: {
        id: 0,
        nombre: '',
      },
      faenasListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Nombre',
          align: 'center',
          sortable: true,
          value: 'nombre',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "blue-grey darken-4 white-text"
        },
      ],
      faenasListBody: [],
      botones:[
        {boton:'crear',tooltip:'Nueva Faena'},
        //{boton:'cargar',tooltip:'Carga Masiva'},
        //{boton:'eliminar',tooltip:'Borrar Todo'}
      ]
    }),
    mounted() {
      this.loadFaenas();
    },
    methods:{
      async loadFaenas(){
        this.mostrarLoading('Cargando listado de faenas...')
        let url = `${this.base_url}faenas`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.faenasListBody = response.data;
          this.ocultarLoading()
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading()
        });
      },
      async saveFaena(){
        // validation
        this.errors = [];
        if(!this.faena.nombre){
          this.errors.push("Debe indicar nombre");
        }else if(this.faena.nombre.length > 20){
          this.errors.push("Tamaño máximo nombre: 20 caracteres");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}faenas`;
        let faenaData = {
          'nombre': this.faena.nombre,
        };
        if(this.faena.id > 0){
          url = url + "/" + this.faena.id;
          await this.axios.put(url, faenaData, this.headers).then((response)=>{
            let index = this.faenasListBody.map(faena => {
              return faena.id;
            }).indexOf(this.faena.id);
            this.faenasListBody.splice(index, 1, response.data);
            this.showSnackBar(false);
          }).catch((error)=>{
            this.validation_message = error;
            this.showSnackBar(true);
          });
        }else{
          await this.axios.post(url, faenaData, this.headers).then((response)=>{
            this.faenasListBody.push(response.data);
            this.showSnackBar(false);
          }).catch((error)=>{
            this.errors = error.response.data;
            this.validation_message = this.errors.join();
            this.showSnackBar(true);
          });
        }
        this.cleanForm();
      },
      editFaena(item) {
        this.faenaIndex = this.faenasListBody.indexOf(item);
        this.faena = Object.assign({}, item);
        this.dialog = true;
        this.title = "Editar Faena";
      },
      async deleteFaena(item) {
        this.$confirm('Desea borrar este faena?').then(res => {
          if(res){
            let url = `${this.base_url}faenas/${item.id}`;
            this.axios.delete(url, this.headers).then((response)=>{
              console.log(response);
              const index = this.faenasListBody.indexOf(item);
              this.faenasListBody.splice(index, 1);
              this.showSnackBar(false);
            }).catch((error)=>{
              this.validation_message = error;
              this.showSnackBar(true);
            });
          }
        });
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      closeModal(){
        this.cleanForm();
        this.dialog = false;
        this.error = null;
        this.title = "Nueva Faena";
      },
      cleanForm(){
        this.faena = {
          id: 0,
          nombre: '',
        };
        this.dialog = false;
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['loading', 'base_url', 'headers']),
      
    },
    components:{
      
    }
  }
</script>